import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Icons } from '@vex/icons/icons';
import { HelperService } from '@vex/services/helper.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from '@vex/services/layout.service';
import { MatSidenav } from '@angular/material/sidenav';
import { MatPaginator } from '@angular/material/paginator';
import { MdePopoverTrigger } from '@material-extended/mde';

@Component({
  selector: 'vex-global-search-card',
  templateUrl: './global-search-card.component.html',
  styleUrls: ['./global-search-card.component.scss']
})
export class GlobalSearchCardComponent extends Icons implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('target', { static: false }) target: MdePopoverTrigger;
  @Output() onSelectCheckBox = new EventEmitter();
  @Output() openConfig = new EventEmitter();
  @Input() item: any = {};
  @Input() selectedItem: any = [];
  isGlobal: boolean = true;
  value: string = '';
  label: string = '';
  right_width: number = 500;
  constructor(
    public helperService: HelperService,
    public dialogRef: MatDialogRef<GlobalSearchCardComponent>,
    public layoutService: LayoutService,
    private dialog: MatDialog
  ) {
    super();
  }

  messages: any[] = []
  ngOnInit(): void {
    let captions = this.item?.SemanticSearch?.Captions ?? [];
    captions.forEach(caption => {
      if (caption?.Highlights) {
        this.messages.push(caption.Highlights);
      } else if (caption?.Text) {
        this.messages.push(caption.Text);
      }
    })
    if (this.selectedItem && this.selectedItem.length) {
    let exists = this.selectedItem.some(x => x.Id === this.item.Id);
      if (exists) {
        this.item['selectedCard'] = true;
      }
    }
  }

  onClose() {
    this.dialogRef.close();
    this.helperService.onClose(true);
  }

  showTooltip(value, label) {
    this.value = value;
    this.label = label;
  }

  getHeight(height: number = 0) {
    const height_inner = (window.innerHeight - height).toString();
    return height_inner + 'px';
  }

  selectCheckbox(item) {
    this.onSelectCheckBox.emit(item);
  }

  onCardSelect() {
    this.item['selectedCard'] = !this.item['selectedCard']
  }

  openDetail(item) {
    let id = item.Id.split('_')[0];
    if(item.itemType == 'Instance') {
      window.open('/deployment/vdc-inventory?id=' + id, '_blank');
    } else if(item.itemType == 'Blueprint') {
      window.open('/blueprintdesigner/list?id=' + id, '_blank');
    } else if(item.itemType == 'Device') {
      window.open('/device/list?id=' + id, '_blank');
    }
  }

  viewConfig(item){
    if(item.RenderedText) {
      this.openConfig.emit(item);
    }
  }
}
